<template>
  <component
    :is="tag"
    class="play-logo"
    aria-label="tobook.link"
  >
    <span
      v-if="!compact"
      class="play-logo__name"
    >tobook</span><span class="play-logo__tld">.link</span>
  </component>
</template>

<script>
/**
 * PlayLogo — token-driven text wordmark for the Play system, replacing the
 * bitmap/SVG logo. "tobook" in the display face + a ".link" pill in the
 * secondary (violet) role, echoing the original speech-bubble mark.
 *
 * Ported from 2q-landing (src/components/play/PlayLogo.vue). This dashboard
 * copy adds a `compact` prop (landing has none yet) — the ".link" sticker on
 * its own, used as the icon mark in the collapsed sidebar.
 *
 * Theme-adaptive for free: ink + secondary tokens flip under `.dark-layout`
 * (see src/styles/tokens.scss), so no skin prop is needed. Size is inherited
 * via `font-size` (`em`-based internals), so the consumer just sets the
 * desired font-size on the element.
 *
 * Renders a <span> by default; pass `tag` (e.g. router-link / a) for a
 * clickable mark.
 */
export default {
  name: 'PlayLogo',
  props: {
    /** Element to render: 'span' | 'a' | 'router-link' | … */
    tag: {
      type: String,
      default: 'span',
    },
    /** Icon-only variant: renders just the ".link" sticker (collapsed nav). */
    compact: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.play-logo {
  display: inline-flex;
  align-items: baseline;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.5rem;
  line-height: 1;
  letter-spacing: -0.03em;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
}

.play-logo__name {
  color: var(--text-strong);
}

/* ".link" sticker — filled violet role with the signature soft tilt. */
.play-logo__tld {
  margin-inline-start: 0.1em;
  padding: 0.08em 0.3em;
  border-radius: var(--radius-sm);
  background: var(--c-secondary);
  color: var(--c-secondary-on);
  transform: rotate(-2deg);
}
</style>
